import swal from "sweetalert";
import {
  CREATE_MEDICAL_SUPLIES_FAIL,
  CREATE_MEDICAL_SUPLIES_REQUEST,
  CREATE_MEDICAL_SUPLIES_SUCCESS,
  FETCH_MEDICAL_SUPLIES_FAIL,
  FETCH_MEDICAL_SUPLIES_REQUEST,
  FETCH_MEDICAL_SUPLIES_SUCCESS,
} from "../../ActionType/MedicalSupliesTypes/MedicalSupliesTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const createMedicalSupliesAction =
  (
    branch_id,
    visit_id,
    place,
    hospital,
    cost,
    date,
    type_of_help,
    type_of_test,
    patientId
  ) =>
    async (dispatch) => {


      // console.log(hospital)
      let hospitalId = [];

      hospital?.map((hospital) => {
        hospitalId.push(hospital.value)
      })
      // return
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };

      dispatch({
        type: CREATE_MEDICAL_SUPLIES_REQUEST,
        payload: [],
      });
      try {
        const response = await api.post(
          "medicalSuplies/create",
          {
            branch_id,
            visit_id,
            type_of_help,
            place,
            // hospital_id: hospital,
            date,
            type_of_test,
            cost,
          },
          config
        );
        const { status, data } = response;

        if (status == 201) {

          let medicalSupplieId = [];
          data?.map((medical) => {
            medicalSupplieId.push(medical?.id)
          })

          storeHospitalMedical(hospital, medicalSupplieId)

          swal({
            title: "Good job!",
            text: "Medical suplies was saved Successfully !",
            icon: "success",
            button: "OK",
            timer: 2000,
          });

          dispatch({
            type: CREATE_MEDICAL_SUPLIES_SUCCESS,
            payload: data,
          });
        }
      } catch (error) {
        console.log(error)
        dispatch({
          type: CREATE_MEDICAL_SUPLIES_FAIL,
          payload: [],
        });
      }
    };

export const getMedicalSupliesAction =
  (
    branch_id,
    perPage,
    page,
    fullname,
    code,
    typeOfHelp,
    city,
    hospital,
    typeOfTest,
    total,
    date,
    from,
    to
  ) =>
    async (dispatch) => {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          branch_id,
          perPage,
          page,
          fullname,
          code,
          typeOfHelp,
          city,
          hospital,
          typeOfTest,
          total,
          date,
          from,
          to,
        },
      };
      dispatch({
        type: FETCH_MEDICAL_SUPLIES_REQUEST,
        payload: [],
      });
      try {
        const response = await api.get("medicalSuplies", config);
        const { status, data } = response;
        console.log(data.data)
        if (status == 200) {
          dispatch({
            type: FETCH_MEDICAL_SUPLIES_SUCCESS,
            payload: { data: data.data, total: data.total },
          });
        }
      } catch (error) {
        console.log(error);
        dispatch({
          type: FETCH_MEDICAL_SUPLIES_FAIL,
          payload: [],
        });
      }
    };

export const updateMedicalSupliesAction =
  (
    ids,
    branch_id,
    visit_id,
    place,
    hospital,
    cost,
    date,
    type_of_help,
    type_of_test,
    patientId
  ) =>
    async (dispatch) => {
      // console.log(hospital)



      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };
      dispatch({
        type: CREATE_MEDICAL_SUPLIES_REQUEST,
        payload: [],
      });
      try {
        const response = await api.post(
          "medicalSuplies/update",
          {
            ids,
            branch_id,
            visit_id,
            type_of_help,
            place,
            
            date,
            type_of_test,
            cost,
          },
          config
        );
        const { status, data } = response;
        // console.log()
        if (status == 200) {
          let medicalSupplieId = [];
       
          data?.map((medical) => {
            medicalSupplieId.push(medical?.id)
          })
          
          console.log(medicalSupplieId)
          storeHospitalMedical(hospital, medicalSupplieId)
          swal({
            title: "Good job!",
            text: "Medical suplies was Update Successfully !",
            icon: "success",
            button: "OK",
            timer: 2000,
          });

          dispatch({
            type: CREATE_MEDICAL_SUPLIES_SUCCESS,
            payload: data,
          });
        }
      } catch (error) {
        console.log(error);
        dispatch({
          type: CREATE_MEDICAL_SUPLIES_FAIL,
          payload: [],
        });
      }
    };

export const exportToExcelMedicalSuplies = async (from, to) => {
  const branch_id = localStorage.getItem("branch_id");
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      from,
      to,
      branch_id,
    },
    responseType: "blob",
  };
  try {
    const response = await api.get("medicalSuplies/export", config);

    const blob = new Blob([response.data], { type: "text/csv" });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);

    link.download = "پێداویستی پزیشکی.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading CSV:", error);
  }
};


const storeHospitalMedical = async (hospitalId, medicalSuplieId) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    const response = await api.post("hospital-medical", { hospital_id: hospitalId, medical_suplies_id: medicalSuplieId }, config)
    console.log(response)
    return response.data;
  } catch (error) {
    console.log(error)
  }
}